export const SEND_OPERATOR_INQUIRY = 'send-operator-inquiry';
const sendOperatorInquiry = ({ fullName, email, phone }) => ({
  type: SEND_OPERATOR_INQUIRY,
  payload: { fullName, email, phone },
});
export default sendOperatorInquiry;
